module.exports = __webpack_public_path__ + "static/media/cindrellawilliams.0927ab4d.svg";